import React, { useState, useEffect } from 'react';
import css from './GlobalTable.less';
import GlobalPagination from '../../components/StyledPagination/GlobalPagination';

import Table from '@/src/components/EditableTable/EditableTable';
import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import Selector from 'src/components/TableColSelector/ColSelector';
import _ from 'lodash';
import _Query from 'src/constrains/Query1';
import {
  onSearchChange,
  onFilterChange,
  onSortChange,
  onSearchClose,
  //setTableSetting,
} from './slice';
import { useDispatch } from 'react-redux';

const GlobalTable = (props) => {
  const _d = useDispatch();
  const {
    columns, //宽度和minWidth不能用%！
    dataSource,
    // disableSelectButton,
    buttonMenu,
    pagination = {},
    id,
    hideRowSelection,
    hideHeader,
    hidePagination,
    expandable,
    current,
    pageSize,
    setCurrent,
    setPageSize,
    total,
    loading,
    rowKey,
    rowSelection = {},
    selectedRowKeys,
    mappedSelectedKeys,
    queryProps = {},
    //={filters,sortList,iniConditions?}
    hideQuery,
    totalText,
    selectedAll,
    setSelectedAll,
    className,
    tableSettings, //redux中保存的配置table columns的key,不传则默认为展示state中的数据
    bulkEditText,
    ...rest
  } = props;

  const data = queryProps.searchConditions;

  const handleOnSearchChange = (e) => {
    _d(onSearchChange({ search: e, key: id }));
  };

  const handleOnFilterChange = (e) => {
    _d(onFilterChange({ filter: e, key: id }));
  };

  const handleOnSortChange = (e) => {
    _d(onSortChange({ sort: e, key: id }));
  };

  const handleOnSearchClose = (e) => {
    _d(onSearchClose({ item: e, key: id }));
  };
  const [allColumns, setAllColumns] = useState([]);

  const saveColumns = (tableSettings || []).length
    ? allColumns.map((o) => {
        if (tableSettings.includes(o.key)) {
          o.default = true;
        } else {
          o.default = false;
        }
        return o;
      })
    : [];
  //const [searchConditions, setSearchConditions]=React.;

  const showSet = allColumns.filter((column) => column.optional);

  const handleColumnsChange = (columnArray) => {
    setAllColumns(columnArray);
    // const allColumnsKey = columnArray.map((column) => {
    //   if (column.default) {
    //     return column.key;
    //   }
    // });
    //_d(setTableSetting({ data: allColumnsKey, key: id }));
  };

  const onChange = (col = []) => {
    handleColumnsChange(col);
  };
  const pageOnChange = (page, pageSize) => {
    setCurrent(page - 1);
  };
  const pageSizeChange = (value) => {
    setPageSize(value.value);
    setCurrent(0);
  };
  useEffect(() => {
    const columnArray = _.cloneDeep(columns || []);
    setAllColumns(columnArray);
  }, [columns]);

  //选择全部
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = dataSource.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };
  //重置设置
  const setReset = () => {
    handleColumnsChange(columns);
  };
  //配置每页展示条数
  const pageSizeOption = [20, 60, 100];

  return (
    <React.Fragment>
      {!hideQuery && (
        <div className={css.queryContainer}>
          <_Query
            onSearchChange={handleOnSearchChange}
            onFilterChange={handleOnFilterChange}
            onSortChange={handleOnSortChange}
            onTagClose={handleOnSearchClose}
            filters={queryProps.filters || []}
            sortList={queryProps.sortList || []}
            searchPlaceholder={queryProps.searchPlaceholder}
            data={data || []}
          />
        </div>
      )}

      {/* {(queryProps.searchListArray.length > 0 ||
        queryProps.filter.length > 0) &&
        !dataSource.length && <TableNoData />} */}
      {dataSource.length && !hideHeader ? (
        <div className={css.tableHeader}>
          <BulkEditor
            bulkEditText={bulkEditText}
            selectAll={selectAll}
            selectedAll={selectedAll}
            buttonMenu={buttonMenu}
            total={total}
            dataSource={dataSource}
            selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
            allSelected={mappedSelectedKeys}
          />
          {showSet.length > 0 && (
            <Selector
              allColumns={saveColumns.length > 0 ? saveColumns : allColumns}
              onChange={onChange}
              setReset={setReset}
            />
          )}
        </div>
      ) : (
        ''
      )}

      <Table
        id={id}
        // className={css.globalTable}
        columns={allColumns}
        dataSource={dataSource}
        className={className}
        rowKey={rowKey}
        pagination={false}
        expandable={expandable}
        {...(!hideRowSelection && { rowSelection })}
        loading={loading}
        {...rest}
      />

      {!hidePagination ? (
        <GlobalPagination
          pageOnChange={pageOnChange}
          totalText={totalText}
          pageSize={pageSize}
          pageSizeOption={pageSizeOption}
          pageSizeChange={pageSizeChange}
          total={total}
          current={current + 1}
          paginationProps={pagination}
          pageSizeWidth={120}
          setCurrent={setCurrent}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
export default GlobalTable;
